import React from 'react';
import { PaymentMethod } from '../../../models';

interface PaymentMethodsProps {
  setFormInfo: React.Dispatch<
    React.SetStateAction<{
      type: string;
      dispatch: PaymentMethod;
    }>
  >;
  setPhase: React.Dispatch<React.SetStateAction<number>>;
  paymentMethods: PaymentMethod[];
  setPaymentMethodSelected?: React.Dispatch<
    React.SetStateAction<PaymentMethod>
  >;
}
function PaymentMethods({
  setFormInfo,
  setPhase,
  paymentMethods,
  setPaymentMethodSelected,
}: PaymentMethodsProps) {
  const handleSelectPaymentMethod = (paymentMethod: PaymentMethod) => {
    setFormInfo({
      type: paymentMethod.slug,
      dispatch: { ...paymentMethod },
    });
    setPhase((prev) => prev + 1);
    if (setPaymentMethodSelected) {
      setPaymentMethodSelected(paymentMethod);
    }
  };

  return (
    <section className="min-w-[90%] min-h-[33vh] relative px-6 py-3 border rounded-lg space-y-5">
      <h1 className="text-xl text-text-gray font-semibold">Métodos de pago</h1>
      <div className="flex flex-wrap justify-center  items-center gap-4">
        {paymentMethods.map((paymentMethod, index) => (
          <button
            key={index}
            type="button"
            onClick={() => handleSelectPaymentMethod(paymentMethod)}
            className="flex flex-col justify-center items-center h-[70px] min-w-[150px] w-full md:w-[45%] border p-6 rounded-lg text-nowrap"
          >
            <p className="font-title lg:text-base text-base text-black font-semibold">
              {paymentMethod.title}
            </p>
          </button>
        ))}
      </div>
    </section>
  );
}

export default PaymentMethods;
